import { Box, IconButton, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Trash2 } from "lucide-react";

const VideoTimestampRange = ({
  videoRef,
  timestamp,
  deleteTimestamp,
  index,
  setTimestamps,
}) => {
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [error, setError] = useState("");

  // Convert HH:MM:SS to seconds
  const timeStringToSeconds = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  };

  // Automatically insert colons in the time string
  const formatTimeInput = (value) => {
    // Remove non-digit characters
    const digits = value.replace(/\D/g, "");

    let formattedTime = digits;

    if (digits.length > 2 && digits.length <= 4) {
      // Insert first colon after hours
      formattedTime = `${digits.slice(0, 2)}:${digits.slice(2)}`;
    } else if (digits.length > 4) {
      // Insert second colon after minutes
      formattedTime = `${digits.slice(0, 2)}:${digits.slice(
        2,
        4
      )}:${digits.slice(4, 6)}`;
    }

    return formattedTime;
  };

  // Handle input changes for 'fromTime' and 'toTime'
  const handleTimeStampChange = (e, setTime) => {
    const formattedTime = formatTimeInput(e.target.value);
    setTime(formattedTime);
    setTimestamps((prevState) => {
      const timestampToBeUpdated = prevState?.find(
        (stamp) => stamp.id === timestamp.id
      );
      if (timestampToBeUpdated) {
        if (e.target.name === "fromTime") {
          timestampToBeUpdated.fromTime = formattedTime;
        } else {
          timestampToBeUpdated.toTime = formattedTime;
        }
      }
      return [...prevState];
    });
  };

  const handleCommentForTimeStamp = (e) => {
    setTimestamps((prevState) => {
      const timestampToBeUpdated = prevState?.find(
        (stamp) => stamp.id === timestamp.id
      );
      if (timestampToBeUpdated) {
        timestampToBeUpdated.comment = e.target.value;
      }
      return [...prevState];
    });
  };

  return (
    <Box sx={{ maxWidth: "512px" }}>
      <Stack my={2} direction={"row"} justifyContent={"space-between"}>
        <Typography>Timestamp {index + 1}</Typography>
        <IconButton
          onClick={() => {
            deleteTimestamp(timestamp?.id);
          }}
        >
          <Trash2 />
        </IconButton>
      </Stack>
      <Stack direction={"row"} alignItems={"center"} gap={2}>
        <label style={{ marginRight: "10px" }}>From :</label>
        <TextField
          type="text"
          value={fromTime}
          name="fromTime"
          onChange={(e) => handleTimeStampChange(e, setFromTime)}
          placeholder="00:00:00"
          inputProps={{
            maxLength: 8,
            style: {
              textAlign: "center",
            },
          }}
          sx={{ width: "10ch" }} // Adjust width slightly for padding
        />

        <label style={{ marginRight: "10px" }}>To :</label>
        <TextField
          type="text"
          value={toTime}
          name="toTime"
          onChange={(e) => handleTimeStampChange(e, setToTime)}
          placeholder="00:00:00"
          inputProps={{
            maxLength: 8,
            style: {
              textAlign: "center",
            },
          }}
          sx={{ width: "10ch", textAlign: "center !important" }} // Adjust width slightly for padding
        />
      </Stack>
      <Stack>
        <Typography my={2}>Add Comments</Typography>
        <TextField
          placeholder="Add your comments for this timestamp here.."
          multiline
          sx={{
            width: "512px",
          }}
          fullWidth
          onChange={handleCommentForTimeStamp}
        />
      </Stack>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </Box>
  );
};

export default VideoTimestampRange;
